"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Keycloak
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class AuthApi extends runtime.BaseAPI {
    /**
     * Fetch a JWT Token
     */
    async getTokenRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling getToken.');
        }
        if (requestParameters.xCLEARClientId === null || requestParameters.xCLEARClientId === undefined) {
            throw new runtime.RequiredError('xCLEARClientId', 'Required parameter requestParameters.xCLEARClientId was null or undefined when calling getToken.');
        }
        if (requestParameters.grantType === null || requestParameters.grantType === undefined) {
            throw new runtime.RequiredError('grantType', 'Required parameter requestParameters.grantType was null or undefined when calling getToken.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling getToken.');
        }
        if (requestParameters.clientSecret === null || requestParameters.clientSecret === undefined) {
            throw new runtime.RequiredError('clientSecret', 'Required parameter requestParameters.clientSecret was null or undefined when calling getToken.');
        }
        if (requestParameters.identificationRequest === null || requestParameters.identificationRequest === undefined) {
            throw new runtime.RequiredError('identificationRequest', 'Required parameter requestParameters.identificationRequest was null or undefined when calling getToken.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xCLEARClientId !== undefined && requestParameters.xCLEARClientId !== null) {
            headerParameters['X-CLEAR-ClientId'] = String(requestParameters.xCLEARClientId);
        }
        const consumes = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.grantType !== undefined) {
            formParams.append('grant_type', requestParameters.grantType);
        }
        if (requestParameters.clientId !== undefined) {
            formParams.append('client_id', requestParameters.clientId);
        }
        if (requestParameters.clientSecret !== undefined) {
            formParams.append('client_secret', requestParameters.clientSecret);
        }
        if (requestParameters.identificationRequest !== undefined) {
            formParams.append('identification_request', requestParameters.identificationRequest);
        }
        const response = await this.request({
            path: `/auth/realms/noque/protocol/openid-connect/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TokenFromJSON(jsonValue));
    }
    /**
     * Fetch a JWT Token
     */
    async getToken(requestParameters) {
        const response = await this.getTokenRaw(requestParameters);
        return await response.value();
    }
}
exports.AuthApi = AuthApi;
//# sourceMappingURL=AuthApi.js.map